import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis";
import { useQuery } from "bi-lib";

interface Props {
    assignmentId?: number;
    subCategoryId?: number;
    assignmentDt?: string;
}

export function useExpenseDetailData({ assignmentId, subCategoryId, assignmentDt }: Props = {}) {
    const apis = useApis();

    const costRateQuery = useQuery({
        queryKey: [QueryKeys.ExpenseCostRate, { assignmentId, subCategoryId, assignmentDt }],
        queryFn: () =>
            apis.engine.expenseDetail.expenseDetailCostRateList({ assignmentId, subCategoryId, assignmentDt }),
        enabled: assignmentId != undefined && subCategoryId != undefined && assignmentDt != undefined,
    });

    return {
        costRate: costRateQuery,
    };
}
